import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, MessageCircle } from 'lucide-react';
import { ROUTES, CONTACT_INFO } from '../../utils/constants';
import styles from './Footer.module.css';

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerColumn}>
          <h4>GC BUSINESS</h4>
          <p>{t('footer.tagline')}</p>
        </div>

        <div className={styles.footerColumn}>
          <h4>{t('footer.quickLinks')}</h4>
          <ul>
            <li><Link to={ROUTES.HOME} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{t('nav.home')}</Link></li>
            <li><a href="https://pay.gcbusiness.space/site/home" target="_blank" rel="noopener noreferrer" aria-label={`${t('nav.openAccount')} (opens in new window)`}>{t('nav.openAccount')}</a></li>
            <li><a href="https://pay.gcbusiness.space/site/home" target="_blank" rel="noopener noreferrer" aria-label="Login (opens in new window)">Login</a></li>
          </ul>
        </div>

        <div className={styles.footerColumn}>
          <h4>Legal</h4>
          <ul>
            <li><Link to={ROUTES.PRIVACY} className={styles.privacyLink}>{t('footer.privacyPolicy')}</Link></li>
            <li><a href="https://pay.gcbusiness.space/docs/terms" target="_blank" rel="noopener noreferrer" className={styles.privacyLink}>Terms and Conditions</a></li>
            <li><a href="https://pay.gcbusiness.space/docs/tcagree" target="_blank" rel="noopener noreferrer" className={styles.privacyLink}>Card Terms</a></li>
            <li><a href="https://pay.gcbusiness.space/docs/prices" target="_blank" rel="noopener noreferrer" className={styles.privacyLink}>Prices</a></li>
            <li><a href="https://pay.gcbusiness.space/docs/eligibility" target="_blank" rel="noopener noreferrer" className={styles.privacyLink}>Eligibility Criteria</a></li>
            <li><Link to={ROUTES.RESTRICTED_JURISDICTIONS} className={styles.privacyLink} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Restricted Jurisdictions</Link></li>
          </ul>
        </div>

        <div className={styles.footerColumn}>
          <h4>{t('footer.contact')}</h4>
          <ul>
            <li>
              <Mail size={16} />
              <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
            </li>
            <li>
              <MessageCircle size={16} />
              <a href={`https://wa.me/${CONTACT_INFO.phone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" aria-label={`GCB PayConcierge WhatsApp ${CONTACT_INFO.phone} (opens in new window)`}>GCB PayConcierge WhatsApp</a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p>
          {t('footer.companyInfo').split('\n').map((line, index, array) => {
            const parts = line.split('FCA Safeguarding');
            if (parts.length > 1) {
              return (
                <React.Fragment key={index}>
                  {parts[0]}
                  <a 
                    href="https://www.fca.org.uk/firms/emi-payment-institutions-safeguarding-requirements" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className={styles.fcaLink}
                  >
                    FCA Safeguarding
                  </a>
                  {parts[1]}
                  {index < array.length - 1 && <br />}
                </React.Fragment>
              );
            }
            return (
              <React.Fragment key={index}>
                {line}
                {index < array.length - 1 && <br />}
              </React.Fragment>
            );
          })}
        </p>
        <div className={styles.footerLinks}>
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
};
